import { InputLabel, TextField } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { NumeralValidation } from ".";
import styled from "styled-components";
import { useQuery } from "react-query";

type Props = {
  id: string;
  label: string;
  placeholder: string;
  defaultValue: string;
  literalValidation?: RegExp;
  numeralValidation?: NumeralValidation;
  multiLine?: boolean;
  onChange: (value: any, errorOccurs: boolean) => any;
  outlined?: boolean;
  errorMessage: string;
  extraInvalidDefinition?: boolean;
  error: boolean;
  width?: number;
};

const GuestInput = (props: Props) => {
  // 未編集
  const [edited, setEdited] = useState(false);

  const validationError = useMemo(() => {
    return props.error;
  }, [props.error]);

  // 初期値が正常かどうか判定し、stateにセット&親コンポーネントに送信する
  useQuery(`init-input-${props.id}`, () => {
    onChange(props.defaultValue);
  });

  const validationOK = useCallback(
    (value: string) => {
      // バリデーションチェック（文字列）
      if (props.literalValidation) {
        const match = value.match(props.literalValidation);
        if (
          (!match || !match[0] || match[0].length !== value.length) &&
          !(match && match.length > 0 && match[0] === "" && value.length === 0)
        ) {
          return false;
        }
      }

      // バリデーションチェック（数値）
      if (props.numeralValidation) {
        if (
          props.numeralValidation.min > parseInt(value) ||
          parseInt(value) > props.numeralValidation.max
        ) {
          return false;
        }
      }

      return true;
    },
    [props],
  );

  const onChange = useCallback(
    (value: string) => {
      // 編集済に
      if (!edited) {
        setEdited(true);
      }
      console.log(value, validationOK(value));
      if (validationOK(value)) {
        props.onChange(value, false);
      } else {
        props.onChange(value, true);
      }
    },
    [edited, props, validationOK],
  );

  const component = useMemo(() => {
    return (
      <GuestInputStyle
        style={{ width: `${props.width ? props.width + 20 : 250}px` }}
      >
        <InputLabel sx={{ fontWeight: "bold" }}>{props.label}</InputLabel>
        <TextField
          variant={props.outlined ? "outlined" : "standard"}
          error={(validationError || props.extraInvalidDefinition) && edited}
          defaultValue={props.defaultValue}
          placeholder={props.placeholder}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          sx={{
            width: props.width ? props.width + "px" : "250px",
            margin: "0 auto 0 auto",
          }}
          size="small"
          multiline={props.multiLine}
          rows={5}
          helperText={
            (validationError || props.extraInvalidDefinition) && edited
              ? props.errorMessage
              : undefined
          }
        />
      </GuestInputStyle>
    );
  }, [
    edited,
    onChange,
    props.defaultValue,
    props.errorMessage,
    props.extraInvalidDefinition,
    props.label,
    props.multiLine,
    props.outlined,
    props.placeholder,
    props.width,
    validationError,
  ]);

  return component;
};

const GuestInputStyle = styled.div`
  margin: 10px auto 10px auto;
`;

export default GuestInput;
